import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { EditUserNameModal } from "./EditUserNameModal";
import { IoIosArrowBack } from "react-icons/io";
import { EditIconButton } from "../../../main/components/EditIconButton";
import { PostUser, User } from "../types";

export function UserDetailsHeader(props: {
  user: User | PostUser;
  onMount: () => void;
}) {
  const { user, onMount } = props;
  const navigate = useNavigate();
  const [showEditNameModal, setShowEditNameModal] = useState<boolean>(false);

  return (
    <>
      <Grid
        container
        display={{ xs: "flex" }}
        paddingBottom={"20px"}
        alignItems={"center"}
      >
        <Grid item xs={1} sm={0.5}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={() => {
                navigate("/users/");
              }}
              sx={{
                width: {
                  xs: "35px",
                  sm: "40px",
                },
                height: {
                  xs: "35px",
                  sm: "40px",
                },
              }}
            >
              <IoIosArrowBack />
            </IconButton>
          </Box>
        </Grid>
        <Grid
          display={"flex"}
          item
          xs={11}
          sm={9.5}
          alignItems={"center"}
          paddingLeft={"10px"}
        >
          <Typography
            sx={{
              marginRight: "10px",
              fontWeight: 500,
              fontSize: {
                xs: "18px",
                sm: "24px",
              },
            }}
          >
            {user.name}
          </Typography>

          <EditIconButton
            onClick={() => {
              setShowEditNameModal(true);
            }}
            tooltipText="Editar Nome do Usuário"
          />
        </Grid>
      </Grid>

      <EditUserNameModal
        onMount={onMount}
        open={showEditNameModal}
        CurrentUser={user}
        setOpen={setShowEditNameModal}
      />
    </>
  );
}
